export const SITE_NAME: string = 'SiteName';
export const SITE_URL: string = 'BaseUrl';
export const REQUIRE_HTTPS: string = 'RequireHttps';
export const REQUIRE_HTTPS_MOVED_PERMENANT: string = 'RequireHttpsMovedPermanently';

export const TRY_REDIRECT_BEFORE_PAGE_LOOKUP: string = 'TryRedirectBeforePageLookup';

export const INDEX_INGRESS_LENGTH: string = 'IndexIngressLength';
export const END_INGRESS_ON_COMPLETE_WORD: string = 'EndIngressOnCompleteWord';
export const ADDITIONAL_STOP_WORDS: string = 'AddStopWords';